<template>
	<el-header class="admin-header" height="60px">
		<div class="header-menu">
			<el-menu :default-active="activeHtml" class="el-menu-demo" mode="horizontal" @select="handleSelect" background-color="#373B42"
			 text-color="#d0d0d0">
				<el-menu-item index="/static/map" v-if="this.menuList.indexOf('CD_100') != -1">地图显示 <div class="line"></div>
				</el-menu-item>
				<el-menu-item index="/static/alarmList" v-if="this.menuList.indexOf('CD_200') != -1">报警管理<div class="line">
					</div>
				</el-menu-item>
				<el-menu-item index="/static/maintenance" v-if="this.menuList.indexOf('CD_300') != -1">维护管理<div class="line">
					</div>
				</el-menu-item>
				<el-menu-item index="/static/contract" v-if="this.menuList.indexOf('CD_400') != -1">合同管理<div class="line"></div>
				</el-menu-item>
				<el-menu-item index="/static/statisticsList/workLoad" v-if="this.menuList.indexOf('CD_500') != -1">数据统计<div class="line"></div>
				<!-- <el-menu-item index="/static/alarmTime" v-if="this.menuList.indexOf('CD_500') != -1">数据统计<div class="line"></div> -->
				</el-menu-item>
				<el-menu-item index="/static/system/manage" v-if="this.menuList.indexOf('CD_600') != -1">系统管理<div class="line">
					</div>
				</el-menu-item>
			</el-menu>
		</div>
		<div class="header-user">
			<div class="user-info" @click="showEditPasswordDialog">
				欢迎您，{{$store.getters.getUserInfo.fullName}}
			</div>
			<div class="user-logout" @click="quit">
				<img src="" height="20">
				<span>
					退出
				</span>
			</div>
		</div>
		<el-dialog title="修改密码" :center="true" :visible.sync="editPasswordDialog" :append-to-body="true"
		 :close-on-click-modal="false" width="500px" custom-class="dialog-style">
			<div class="dialog-content" style="height:130px;">
				<el-form ref="form" :model="update" label-width="120px">
					<el-form-item label="新密码">
						<el-input v-model="update.newPassword" type="password"></el-input>
					</el-form-item>
					<el-form-item label="确认密码">
						<el-input v-model="update.repeatPassword" type="password"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editPasswordDialog = false">取 消</el-button>
				<el-button type="primary" @click="editPassword()">确认修改</el-button>
			</span>
		</el-dialog>
	</el-header>
</template>

<script>
	import CommonJs from "@/assets/js/common/common.js";
	import User from "@/assets/js/system/user.js";
	export default {
		name: 'AdminHeader',
		data() {
			return {
				editPasswordDialog: false,
				activeHtml: '/static/map',
				update: {
					newPassword: '',
					repeatPassword: '',
				},
				menuList: []
			}
		},
		methods: {
			handleSelect(key, keyPath) {
				this.activeHtml = key;
				this.$router.push({
					path: keyPath[0]
				});
			},
			showEditPasswordDialog() {
				this.editPasswordDialog = true;
				this.update = {
					newPassword: '',
					repeatPassword: '',
				};
			},
			editPassword() {
				let param = {};
				if (this.update.newPassword == '' || this.update.newPassword == null || this.update.newPassword == undefined) {
					this.utils.tipsAlert('新密码不能为空');
					return;
				}
				if (this.update.newPassword != this.update.repeatPassword) {
					this.utils.tipsAlert('确认密码跟新密码不同，请重新填写确认密码');
					return;
				}
				param.userId = this.$store.getters.getUserInfo.userId;
				param.password = this.update.newPassword;
				User.updataNewUser(param, param.userId).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.utils.editAlert();
						this.editPasswordDialog = false;
					} else {
						this.utils.tipsAlert(data.message);
					}
				}).catch((response) => {})
			},
			quit() {
				CommonJs.logout().then((response) => {
					const data = response.data;
					this.$router.push({
						path: '/login'
					});
				}).catch((response) => {})
			}
		},
		created() {
			this.activeHtml = this.$route.path;
			this.menuList = this.$store.getters.getMenuPermission;
		}
	}
</script>

<style>
	.header-menu .el-menu--horizontal>.el-menu-item {
		text-align: center;
		font-weight: bold;
	}

	.header-menu .el-menu--horizontal>.el-menu-item.is-active .line {
		-webkit-transform: perspective(0.5em) rotateX(40deg);
		height: 5px;
		background-color: #43DC7D;
		width: 40px;
		margin: 0 60px;
		position: absolute;
		bottom: 0;
		left: 0
	}

	.header-menu .el-menu--horizontal>.el-menu-item.is-active {
		border-bottom: none;
		color: #43DC7D;
	}

	.header-menu .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
	.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
		color: #43DC7D;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue